const lessTenAddZero = (number: number) => number < 10 ? `0${number}` : number;

export default lessTenAddZero;